export default __webpack_public_path__ + "static/media/Helm of Celestial Radiance.7e73e6e7.jpg";